import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, notification } from "antd";
import { FiArrowLeft } from "react-icons/fi";
import JsonFormatter from "react-json-formatter";
import config from "../../config";
import serviceHome from "../../services/home";
import { removeStorageWhenLogout } from "../../config/helper";

const ModalLastMessage = ({ openModal, onClose = () => {} }) => {
	const navigate = useNavigate();

	const [theLastChatHistory, setTheLastChatHistory] = useState("");

	const handleGetLastChatHistory = async () => {
		const getUserDataFromStorage = localStorage.getItem("userData");
		const response = await serviceHome.getLastChat(
			`?userName=${getUserDataFromStorage}`
		);
		if (response.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				navigate("/signin");
			}, config.timeout);
		}
		if (response.httpStatus === 404) {
			setTheLastChatHistory("You don't have any chat history.");
		}
		if (response.httpStatus === 200) {
			setTheLastChatHistory(
				response.data || "You don't have any chat history."
			);
		}
	};

	useEffect(() => {
		handleGetLastChatHistory();
	}, []);

	return (
		<Modal
			footer={null}
			className="profile-modal"
			open={openModal}
			onCancel={() =>
				onClose({
					adminPromptShow: true,
					lastMessageShow: false,
				})
			}
			destroyOnClose
		>
			<div className="top-section">
				<div className="user-profile">
					<Button
						className="user-profile-icon"
						icon={<FiArrowLeft size={24} />}
						onClick={() =>
							onClose({
								adminPromptShow: true,
								lastMessageShow: false,
							})
						}
					/>
					Last Message
				</div>
				<div
					className="user-profile-wrapper"
					style={{ marginBottom: 24 }}
				>
					<span>Last Message</span>
				</div>
				<div className="prompt-wrapper-with-beautify">
					{theLastChatHistory?.split("\n").map((content, key) => {
						let newText = content;
						if (content.includes('{"messages":')) {
							newText = (
								<JsonFormatter json={content} tabWith={4} />
							);
						}

						return <div key={key}>{newText}</div>;
					})}
				</div>
			</div>
		</Modal>
	);
};

export default ModalLastMessage;
